import imgEmptyNoData from 'assets/images/img_emptyview_no_data.png';
import ChargeHelper from 'features/Charge/chargeHelper';
import MaintainerHelper, { MaintainerConstants } from 'features/Maintainer/maintainerHelper';
import { AppCustomDialogHelper } from 'general/components/AppDialogCustom';
import DropdownFilterTable from 'general/components/DropdownFilterTable';
import DropdownTableConfigColumn from 'general/components/DropdownTableConfigColumn';
import KTFormSearch from 'general/components/OtherKeenComponents/Forms/KTFormSearch';
import KTDropdownFilter from 'general/components/OtherKeenComponents/KTDropdownFilter';
import KTLabel, { KTLabelSize } from 'general/components/OtherKeenComponents/KTLabel';
import KTPagination, {
    KTPaginationColor,
} from 'general/components/OtherKeenComponents/KTPagination';
import KTTable from 'general/components/OtherKeenComponents/KTTable';
import tableStyle from 'general/components/OtherKeenComponents/KTTable/tableStyle';
import KTTooltip from 'general/components/OtherKeenComponents/KTTooltip';
import CustomDateRangePicker, {
    dateFilter,
    getDateFilterOption,
} from 'general/components/Others/CustomDateRangePicker';
import EmptyView from 'general/components/Others/EmptyView';
import MenuActionDropdown from 'general/components/Others/MenuActionDropdown';
import CustomDropdownMultiChoiceView from 'general/components/quybka/Others/CustomDropdownMultiChoiceView';
import FileUploadView from 'general/components/quybka/Uploads/FileUploadView';
import AppColors from 'general/constants/AppColors';
import AppConstants from 'general/constants/AppConstants';
import AppRoute from 'general/constants/AppRoute';
import ToastHelper from 'general/helpers/ToastHelper';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import useConfigTableColumn from 'hooks/useConfigTableColumn';
import useRouter from 'hooks/useRouter';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import DialogAddMaintainerTicketView from '../DialogAddMaintainerTicketView';
import DialogMaintainerUpdateTicketView from '../DialogMaintainerUpdateTicketView';
import DialogMaintainerCompleteTicketView from '../DialogMaintainerCompleteTicketView';
import DialogUploadInvoiceDocumentView from '../DialogUploadInvoiceDocumentView';
import { KTBSDropdownDirections } from 'general/components/OtherKeenComponents/KTBSDropdown';
import DialogAdminAssignTicketView from '../DialogAdminAssignTicketView';
import DialogCreateAcceptanceView from '../DialogCreateAcceptanceView';
import MaintainerTicketListFilterView from './components/MaintainerTicketListFilterView';
import * as ExcelJS from 'exceljs';
import AppConfigs from 'general/constants/AppConfigs';

const defaultColumnIds = [
    'TICKET_CODE',
    'STATION_NAME',
    'POINT_NAME',
    'DESCRIPTION',
    'TICKET_ADDRESS',
    'DISTANCE',
    'TYPE',
    'MAINTAINER_NAME',
    'PRIORITY',
    'STATUS',
    'CREATED_BY',
    'CREATED_AT',
    'DEADLINE',
    'COMPLETED_DATE',
    'PAYMENT_STATUS',
    'TOTAL_AMOUNT',
    'INVOICE',
];

function MaintainerTicketListView(props) {
    // ---- params ----
    const { maintainerUserId, isMine = false, stationId, hasAppTab = false, chargeStation } = props;
    const { t } = useTranslation();
    const router = useRouter();
    const { user, permissionList } = useSelector((state) => state.auth);
    const app = useSelector((state) => state.app);
    const areaTree = useSelector((state) => state.app.areaTree);
    const adminRole =
        user?.role === AppConstants.userRole.admin || user?.role === AppConstants.userRole.operator;
    const agencyRole = user?.role === AppConstants.userRole.agency;
    const agencyStation = user?.role === 'AGENCY' && (
        user?.agency?.primaryRole === 'INVESTOR' ||
        user?.agency?.primaryRole === 'COINVESTOR' ||
        user?.agency?.primaryRole === 'LANDLORD' ||
        (user?.agency?.primaryRole === 'SALE' && user?.agencyId === 1)
    );
    const [operatorList, setOperatorList] = useState([]);
    const [filter, setFilter] = useState(MaintainerHelper.Filter.ticketList);
    const [filterDropdown, setFilterDropdown] = useState(MaintainerHelper.Filter.ticketList);
    const [ticketList, setTicketList] = useState([]);
    const [total, setTotal] = useState(0);
    const [currentLat, setCurrentLat] = useState();
    const [currentLon, setCurrentLon] = useState();
    const isMaintainerStation = useMemo(() => isMine && stationId, [isMine, stationId]);
    const fullColumns = useMemo(() => {
        return [
            {
                id: 'TICKET_CODE',
                name: UIHelper.buildTableColumn('Mã công việc'),
                selector: (row) => {
                    return (
                        <span
                            onClick={() => {
                                if (isMaintainerStation) {
                                    Utils.openInNewTab(`${AppRoute.ticketList}/${row.ticketId}`)
                                }
                            }}
                        >
                            {row?.ticketCode ?? (row.ticketId)}
                        </span>
                    )
                },
                style: isMaintainerStation ? tableStyle.columns.link : tableStyle.columns.normal,
                sortable: false,
                width: '150px',
            },
            {
                id: 'STATION_NAME',
                name: UIHelper.buildTableColumn('Trạm sạc'),
                minWidth: '240px',
                selector: (row) => {
                    return (
                        <KTTooltip offset={[0, 0]} text={row?.chargeStation?.name ?? ''}>
                            <span
                                onClick={() => {
                                    Utils.openInNewTab(`${AppRoute.stationList}/${row?.chargeStation?.stationId}`)
                                }}
                            >{row?.chargeStation?.name ?? ''}</span>
                        </KTTooltip>
                    );
                },
                style: tableStyle.columns.link,
                sortable: false,
                omit: stationId,
            },
            {
                id: 'POINT_NAME',
                name: UIHelper.buildTableColumn('Trụ sạc lỗi'),
                selector: (row) => {
                    return (
                        <KTTooltip offset={[0, 0]} text={row?.chargePoint?.pointCode ?? ''}>
                            <span
                                onClick={() => {
                                    Utils.openInNewTab(`${AppRoute.pointList}/${row?.chargePoint?.pointId}`)
                                }}
                            >{row?.chargePoint?.pointCode ?? ''}</span>
                        </KTTooltip>
                    );
                },
                style: tableStyle.columns.link,
                sortable: false,
                width: '130px',
            },
            {
                id: 'DESCRIPTION',
                name: UIHelper.buildTableColumn('Mô tả của người báo lỗi'),
                selector: (row) => row?.description,
                style: tableStyle.columns.normal,
                minWidth: '250px',
                wrap: true,
            },
            {
                id: 'TICKET_ADDRESS',
                name: UIHelper.buildTableColumn('Vị trí trạm sạc'),
                selector: (row) => {
                    const area = ChargeHelper.Utils.getAreaById([areaTree], row?.chargeStation?.areaId);
                    let parentArea;
                    if (area?.typeCode === 'W') {
                        parentArea = ChargeHelper.Utils.getAreaById([areaTree], area?.parentId);
                    }
                    const addressResult = [row?.chargeStation?.address, area?.name, parentArea?.name]
                        .filter(Boolean)
                        .join(', ');
                    return (
                        <KTTooltip text={addressResult} offset={[0, 0]}>
                            <span>{addressResult?.length > 0 ? addressResult : ''}</span>
                        </KTTooltip>
                    );
                },
                style: tableStyle.columns.normal,
                sortable: false,
                minWidth: '240px',
                omit: stationId || !!maintainerUserId,
            },
            {
                id: 'DISTANCE',
                name: UIHelper.buildTableColumn('Khoảng cách'),
                selector: (row) => {
                    let distance;
                    if (isMine) {
                        if (currentLat && currentLon) {
                            distance = Utils.calculateDistance(currentLat, currentLon, row.chargeStation?.latitude, row.chargeStation?.longitude);
                        } else {
                            distance = Utils.calculateDistance(user?.agency?.workAddress?.latitude, user?.agency?.workAddress?.longitude, row.chargeStation?.latitude, row.chargeStation?.longitude);
                        }
                    } else {
                        distance = Utils.calculateDistance(filter.latitude, filter.longitude, row.chargeStation?.latitude, row.chargeStation?.longitude);
                    }
                    return Utils.formatNumber(distance) + ' km';
                },
                style: tableStyle.columns.normal,
                sortable: false,
                width: '130px',
                omit: adminRole || stationId,
            },
            {
                id: 'TYPE',
                name: UIHelper.buildTableColumn('Loại công việc'),
                selector: (row) => _.find(MaintainerHelper.Data.ticketTypeOptions, (item) => item.value === row?.type)?.name,
                style: tableStyle.columns.normal,
                sortable: false,
                width: '130px',
            },
            {
                id: 'MAINTAINER_NAME',
                name: UIHelper.buildTableColumn('Kỹ thuật viên'),
                selector: (row) => {
                    return (
                        <KTTooltip offset={[0, 0]} text={row?.user?.fullname ?? ''}>
                            <span
                                onClick={() => {
                                    if (adminRole) {
                                        Utils.openInNewTab(`${AppRoute.maintainerList}/${row?.user?.agency?.agencyId ?? ''}`)
                                    }
                                }}
                            >{row?.user?.fullname ?? ''}</span>
                        </KTTooltip>
                    );
                },
                style: adminRole ? tableStyle.columns.link : tableStyle.columns.normal,
                sortable: false,
                width: '140px',
                omit: !adminRole && !isMine && !agencyStation || !!maintainerUserId,
            },
            {
                id: 'PRIORITY',
                name: UIHelper.buildTableColumn('Độ ưu tiên'),
                selector: (row) => {
                    return (
                        <KTLabel
                            text={MaintainerHelper.Utils.getTicketPriorityName(row?.priority)}
                            isInline={true}
                            size={KTLabelSize.medium}
                            additionalClassName={`label-light-${MaintainerHelper.Utils.getTicketPriorityColor(row?.priority)}`}
                        />
                    );
                },
                style: tableStyle.columns.normal,
                width: '130px',
            },
            {
                id: 'STATUS',
                name: UIHelper.buildTableColumn('Trạng thái công việc'),
                selector: (row) => {
                    return (
                        <KTLabel
                            text={MaintainerHelper.Utils.getTicketStatusName(row?.status)}
                            isInline={true}
                            size={KTLabelSize.medium}
                            additionalClassName={`label-light-${MaintainerHelper.Utils.getTicketStatusColor(row.status)}`}
                            additionalDescription={row?.cancelReason}
                        />
                    );
                },
                sortable: false,
                width: '150px',
                omit: !adminRole && !isMine && !agencyStation,
            },
            {
                id: 'CREATED_BY',
                name: UIHelper.buildTableColumn('Người báo lỗi'),
                selector: (row) => row?.createdBy?.fullname,
                style: tableStyle.columns.normal,
                sortable: false,
                minWidth: '180px',
            },
            {
                id: 'CREATED_AT',
                name: UIHelper.buildTableColumn('Thời gian gửi lỗi'),
                selector: (row) => Utils.formatDateTimeToString(row?.createdAt, 'DD/MM/YYYY - HH:mm'),
                style: tableStyle.columns.normal,
                sortable: false,
                width: '160px',
            },
            {
                id: 'DEADLINE',
                name: UIHelper.buildTableColumn('Thời gian cần xử lý'),
                selector: (row) => Utils.formatDateTimeToString(row?.deadline, 'DD/MM/YYYY - HH:mm'),
                style: tableStyle.columns.normal,
                sortable: false,
                width: '160px',
            },
            {
                id: 'COMPLETED_DATE',
                name: UIHelper.buildTableColumn('Thời gian hoàn thành'),
                selector: (row) => Utils.formatDateTimeToString(row?.completedAt, 'DD/MM/YYYY - HH:mm'),
                style: tableStyle.columns.normal,
                sortable: false,
                width: '160px',
                omit: !adminRole && !isMine && !agencyStation,
            },
            {
                id: 'PAYMENT_STATUS',
                name: UIHelper.buildTableColumn('Trạng thái thanh toán'),
                selector: (row) => {
                    return (
                        <KTLabel
                            text={MaintainerHelper.Utils.getPaymentStatusName(row?.paymentStatus)}
                            isInline={true}
                            size={KTLabelSize.medium}
                            additionalClassName={`label-light-${MaintainerHelper.Utils.getPaymentStatusColor(row.paymentStatus)}`}
                        />
                    );
                },
                sortable: false,
                width: '170px',
                omit: !adminRole && !isMine && !agencyStation,
            },
            {
                id: 'TOTAL_AMOUNT',
                name: UIHelper.buildTableColumn('Tổng chi phí', 'VNĐ'),
                selector: (row) => Utils.formatNumber(row?.amount),
                style: tableStyle.columns.normal,
                sortable: false,
                width: '160px',
                right: true,
                omit: !adminRole && !isMine && !agencyStation,
            },
            {
                id: 'INVOICE',
                name: UIHelper.buildTableColumn('Hóa đơn thanh toán'),
                selector: (row) => {
                    return row?.invoiceDocument?.length > 0 ? (
                        <span
                            className="hover-opacity-60 cursor-pointer"
                            onClick={() => {
                                handleViewFiles(row?.invoiceDocument);
                            }}
                        >
                            {`Xem chi tiết (${row?.invoiceDocument?.length})`}
                        </span>
                    ) : (
                        <></>
                    );
                },
                style: tableStyle.columns.link,
                sortable: false,
                width: '160px',
                omit: !adminRole && !isMine && !agencyStation,
            },
            {
                name: UIHelper.buildTableColumn('Thao tác'),
                width: agencyStation ? '100px' : '130px',
                style: {
                    position: 'sticky',
                    right: 0,
                    backgroundColor: '#fff',
                    borderLeft: '1px solid #ebedfe',
                },
                wrap: true,
                center: isMaintainerStation || agencyStation,
                cell: (row) => {
                    return (
                        <MenuActionDropdown
                            menuAction={[
                                {
                                    iconElement: (
                                        <i
                                            className="fa-regular fa-eye"
                                            style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                        ></i>
                                    ),
                                    text: 'Xem chi tiết',
                                    click: () => {
                                        if (!stationId && !maintainerUserId) {
                                            router.navigate(`${row.ticketId}`);
                                        } else {
                                            router.navigate(`ticket/${row.ticketId}`)
                                        }
                                    },
                                    show: true,
                                },
                                {
                                    iconElement: (
                                        <i
                                            className="fa-regular fa-pen-to-square"
                                            style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                        ></i>
                                    ),
                                    text: 'Chỉnh sửa',
                                    click: () => {
                                        handleAddNew(row);
                                    },
                                    show: adminRole && ![
                                        MaintainerConstants.TicketStatus.DONE,
                                        MaintainerConstants.TicketStatus.CANCEL,
                                    ].includes(row?.status)
                                        && !isMaintainerStation,
                                },
                                {
                                    iconElement: (
                                        <i
                                            className="fa-regular fa-briefcase"
                                            style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                        ></i>
                                    ),
                                    text: 'Nhận việc',
                                    click: () => {
                                        MaintainerHelper.UI.showDialogConfirmMaintainerAssignTicket(row, () => {
                                            getTicketList(filter);
                                        })
                                    },
                                    show: !adminRole && [
                                        MaintainerConstants.TicketStatus.TODO,
                                    ].includes(row?.status)
                                        && !Utils.isValid(row?.userId)
                                        && !isMaintainerStation && !agencyStation,
                                },
                                {
                                    iconElement: (
                                        <i
                                            className={`fa-regular fa-money-check-dollar-pen`}
                                            style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                        ></i>
                                    ),
                                    text: 'Nghiệm thu thanh toán',
                                    click: () => {
                                        handleAdminCreateAcceptance(row);
                                    },
                                    show: adminRole && [
                                        MaintainerConstants.TicketStatus.DONE,
                                    ].includes(row?.status)
                                        && [
                                            MaintainerConstants.TicketStatus.PENDING,
                                        ].includes(row?.paymentStatus)
                                        && !isMaintainerStation,
                                },
                                {
                                    iconElement: (
                                        <i
                                            className="fa-regular fa-xmark-circle"
                                            style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                        ></i>
                                    ),
                                    text: 'Hủy công việc',
                                    click: () => {
                                        MaintainerHelper.UI.showDialogConfirmCancelTicket(row, () => {
                                            getTicketList(filter);
                                        });
                                    },
                                    show: adminRole && ![
                                        MaintainerConstants.TicketStatus.CANCEL,
                                    ].includes(row?.status)
                                        && !isMaintainerStation,
                                },
                                {
                                    iconElement: (
                                        <i
                                            className={`fa-regular fa-trash-can`}
                                            style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                        ></i>
                                    ),
                                    text: 'Xóa công việc',
                                    click: () => {
                                        MaintainerHelper.UI.showDialogConfirmDeleteTicket(row, () => {
                                            getTicketList(filter);
                                        });
                                    },
                                    show: adminRole && [
                                        MaintainerConstants.TicketStatus.CREATED,
                                        MaintainerConstants.TicketStatus.REJECTED,
                                        MaintainerConstants.TicketStatus.CANCEL,
                                    ].includes(row?.status)
                                        && !isMaintainerStation,
                                },
                                {
                                    iconElement: (
                                        <i
                                            className={`fa-regular fa-check-circle`}
                                            style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                        ></i>
                                    ),
                                    text: 'Duyệt công việc',
                                    click: () => {
                                        MaintainerHelper.UI.showDialogConfirmApprovalTicket(row, () => {
                                            getTicketList(filter);
                                        });
                                    },
                                    show: adminRole && [
                                        MaintainerConstants.TicketStatus.PENDING,
                                    ].includes(row?.status)
                                        && !isMaintainerStation,
                                },
                                {
                                    iconElement: (
                                        <i
                                            className={`fa-regular fa-sitemap`}
                                            style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                        ></i>
                                    ),
                                    text: 'Phân phối công việc',
                                    click: () => {
                                        handleAdminAssignTicket(row);
                                    },
                                    show: adminRole && [
                                        MaintainerConstants.TicketStatus.CREATED,
                                        MaintainerConstants.TicketStatus.REJECTED,
                                    ].includes(row?.status)
                                        && !isMaintainerStation
                                        && row?.assignmentMode === 'ASSIGNED',
                                },
                                {
                                    iconElement: (
                                        <i
                                            className={`fa-regular fa-file-upload`}
                                            style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                        ></i>
                                    ),
                                    text: 'Tải lên hóa đơn mua hàng',
                                    click: () => {
                                        handleUploadInvoiceDocument(row);
                                    },
                                    show: adminRole && [
                                        MaintainerConstants.TicketStatus.DONE,
                                    ].includes(row?.status)
                                        && !isMaintainerStation,
                                },
                                {
                                    iconElement: (
                                        <i
                                            className={`fa-regular fa-map-location-dot`}
                                            style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                        ></i>
                                    ),
                                    text: 'Chỉ đường',
                                    click: () => {
                                        handleTicketDirection(row);
                                    },
                                    show: !adminRole && !isMaintainerStation && !agencyStation,
                                },
                                {
                                    iconElement: (
                                        <i
                                            className={`fa-regular fa-xmark-circle`}
                                            style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                        ></i>
                                    ),
                                    text: 'Từ chối công việc',
                                    click: () => {
                                        MaintainerHelper.UI.showDialogConfirmRejectTicket(row, () => {
                                            getTicketList(filter);
                                        });
                                    },
                                    show: isMine && [
                                        MaintainerConstants.TicketStatus.TODO,
                                    ].includes(row?.status)
                                        && !isMaintainerStation,
                                },
                                {
                                    iconElement: (
                                        <i
                                            className={`fa-regular fa-screwdriver-wrench`}
                                            style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                        ></i>
                                    ),
                                    text: 'Cập nhật nội dung sửa chữa',
                                    click: () => {
                                        handleUpdateTicket(row);
                                    },
                                    show: !adminRole && [
                                        MaintainerConstants.TicketStatus.CHECKIN,
                                    ].includes(row?.status)
                                        && !isMaintainerStation,
                                },
                                {
                                    iconElement: (
                                        <i
                                            className={`fa-regular fa-check-circle`}
                                            style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                        ></i>
                                    ),
                                    text: 'Hoàn thành công việc',
                                    click: () => {
                                        handleConfirmCompleteTicket(row);
                                    },
                                    show: !adminRole && [
                                        MaintainerConstants.TicketStatus.APPROVAL,
                                    ].includes(row?.status)
                                        && !isMaintainerStation,
                                },
                                {
                                    iconElement: (
                                        <i
                                            className={`fa-regular fa-file-arrow-up`}
                                            style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                        ></i>
                                    ),
                                    text: 'Tạo hóa đơn mua hàng',
                                    click: () => {
                                        handleUploadInvoiceDocument(row);
                                    },
                                    show: !adminRole && [
                                        MaintainerConstants.TicketStatus.DONE,
                                    ].includes(row?.status)
                                        && !isMaintainerStation
                                        && !agencyStation,
                                },

                            ]}
                        />
                    );
                },
            },
        ];
    }, [t, operatorList, areaTree, user, filter, adminRole, isMine, currentLat, currentLon, isMaintainerStation, maintainerUserId, stationId, agencyStation]);

    const prefKey = useMemo(() => {
        const userId = user.userId;
        const pathName = router.pathname;
        const key = `${userId}_${pathName}`;
        return key;
    }, [user, router]);
    const [fullColumnIds, setFullColumnIds] = useState(
        fullColumns?.map((row) => row?.id).filter(Boolean) || []
    );
    const {
        columnIds,
        columns,
        onChangeCheckboxValue,
        saveChanges,
        resetDefaultTableColumn,
        onSelectAll,
        onUnSelectAll,
        fullColumnsSorted,
        fullColumnsIdSorted,
    } = useConfigTableColumn(prefKey, fullColumnIds, defaultColumnIds, fullColumns);

    const classifyOperators = (operators) => {
        setOperatorList(
            operators?.map((operator) => ({ operatorId: operator.operatorId, name: operator.name }))
        );
    };

    useEffect(() => {
        if (app.appConfig) {
            classifyOperators(app.appConfig.operators ?? []);
        }
    }, [app.appConfig]);

    useEffect(() => {
        getTicketList(filter);
    }, [filter, isMine, stationId, adminRole, agencyStation]);

    useEffect(() => {
        handleGetCurrentLocation();
    }, [])

    const [selectedChargeStation, setSelectedChargeStation] = useState([]);
    const dropdownStationEl = useMemo(() => {
        return (
            <CustomDropdownMultiChoiceView
                id="stationId"
                name="stationId"
                toggleElement={({ showError }) => (
                    <button
                        className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between ${showError ? 'border-invalid' : ''}`}
                        style={{
                            overflowX: 'auto',
                            overflowY: 'hidden'
                        }}
                        type="button"
                    >
                        {selectedChargeStation?.length > 0 ? selectedChargeStation.map(item => item.name).join(', ') : 'Chọn trạm sạc'}
                    </button>
                )}
                selectedValue={selectedChargeStation}
                dropdownMenuItems={[{ name: 'Trạm sạc', role: 'STATION' }]}
                getSubItems={async (item) => {
                    try {
                        return await ChargeHelper.API.requestGetChargeStationList(
                            Utils.filterParams({
                                page: item?.page || 0,
                                limit: 10,
                                q: item?.q || '',
                            })
                        ).then((data) => {
                            return {
                                values: data.chargeStations?.map((station) => ({
                                    id: station?.stationId,
                                    name: station?.name,
                                    item: station,
                                })),
                                total: data.total,
                            };
                        });
                    } catch (error) {
                        console.error('Error fetching station list:', error);
                        return { values: [], total: 0 };
                    }
                }}
                dropdownMenuStyle={{ maxHeight: '30vh' }}
                dropdownMenuClassName="overflow-auto w-100"
                onChange={(value) => {
                    setSelectedChargeStation(value);
                }}
                onSave={(value) => {
                    MaintainerHelper.Filter.ticketList = {
                        ...MaintainerHelper.Filter.ticketList,
                        stationId: value?.length > 0 ? value.map(item => item.id).join(', ') : '',
                        page: 0,
                    };
                    handleRefresh();
                }}
                enableCheckValid
                isDropdownForm={true}
                searchable={true}
                searchFormClassName="mx-3 my-1 search-form-border"
                defaultValue={{
                    name: 'Trạm sạc',
                    role: 'STATION',
                }}
                idCheckType='id'
                direction={hasAppTab ? KTBSDropdownDirections.up : KTBSDropdownDirections.down}
            />
        );
    }, [selectedChargeStation, hasAppTab]);

    // ---- methods ----
    const handleGetCurrentLocation = () => {
        if (!navigator.geolocation) {
            ToastHelper.showError('Trình duyệt không hỗ trợ Geolocation');
            return;
        }

        navigator.geolocation.getCurrentPosition(
            (position) => {
                const { latitude, longitude } = position.coords;
                setCurrentLat(latitude);
                setCurrentLon(longitude);
            },
            (error) => {
                console.error('Geolocation error:', error);
            },
            {
                enableHighAccuracy: false,
                timeout: 10000,
                maximumAge: 60000,
            }
        );
    }

    const getTicketList = async (currentFilter = {}) => {
        const fetchTickets = async (params) => {
            let cleanedParams = _.pickBy(params, (value) => value != null && value !== '');
            if (!!stationId) {
                cleanedParams.stationId = stationId;
            }
            if (!!maintainerUserId) {
                cleanedParams.userId = maintainerUserId;
            }

            if (!adminRole && !isMine && !agencyStation) {
                cleanedParams = _.omit(cleanedParams, [
                    'selectedValue',
                    'from',
                    'to',
                    'hasFee',
                    'paymentStatus',
                    'status',
                ]);
            } else {
                cleanedParams = _.omit(cleanedParams, [
                    'locationType',
                    'latitude',
                    'longitude',
                ]);
            }

            if (cleanedParams.timeFilterType === 'CREATED_DATE') {
                cleanedParams = _.omit(cleanedParams, ['selectedValue', 'from', 'to', 'timeFilterType'])
            } else {
                cleanedParams = _.omit(cleanedParams, ['createdSelectedValue', 'createdFrom', 'createdTo', 'timeFilterType'])
            }

            try {
                const data = isMine
                    ? await MaintainerHelper.API.requestGetMyTicket(cleanedParams)
                    : await MaintainerHelper.API.requestGetTicketList(cleanedParams);

                const { tickets = [], total = 0 } = data || {};
                setTicketList(tickets);
                setTotal(total);
            } catch (error) {
                const reason = error?.response?.data?.reason || 'Lỗi tải danh sách ticket';
                ToastHelper.showError(reason);
                setTicketList([]);
                setTotal(0);
            }
        };

        if (adminRole || agencyStation || isMine) {
            await fetchTickets(currentFilter);
            return;
        }

        let filterWithLocation = { ...currentFilter };

        const hasLocation = !!filterWithLocation.latitude && !!filterWithLocation.longitude;

        if (!hasLocation && user?.agency?.workAddress?.latitude && user?.agency?.workAddress?.longitude) {
            const { latitude, longitude } = user.agency.workAddress;

            filterWithLocation = {
                ...filterWithLocation,
                latitude,
                longitude,
            };

            setFilter((prev) => ({ ...prev, latitude, longitude }));
            setFilterDropdown((prev) => ({ ...prev, latitude, longitude }));

            MaintainerHelper.Filter.ticketList = {
                ...MaintainerHelper.Filter.ticketList,
                latitude,
                longitude,
            };
        }

        const finalHasLocation = !!filterWithLocation.latitude && !!filterWithLocation.longitude;

        if (!finalHasLocation) {
            setTicketList([]);
            setTotal(0);
            return;
        }

        await fetchTickets(filterWithLocation);
    };

    const handleViewFiles = (files) => {
        AppCustomDialogHelper.show(
            'Tệp đính kèm',
            <FileUploadView
                pathList={files}
                onCancel={() => {
                    AppCustomDialogHelper.hide();
                }}
            />,
            'md',
            false,
            true
        );
    };

    const updateFilter = (key, value) => {
        MaintainerHelper.Filter.ticketList = { ...MaintainerHelper.Filter.ticketList, [key]: value };
        setFilter(MaintainerHelper.Filter.ticketList);
        setFilterDropdown(MaintainerHelper.Filter.ticketList);
    };

    const handleRefresh = () => {
        setFilter({ ...MaintainerHelper.Filter.ticketList });
    };

    const handleAddNew = (row) => {
        AppCustomDialogHelper.show(
            !!row ? 'Sửa công việc' : 'Thêm công việc',
            <DialogAddMaintainerTicketView
                item={row}
                chargeStation={chargeStation}
                onCancel={() => AppCustomDialogHelper.hide()}
                onDone={() => {
                    AppCustomDialogHelper.hide();
                    handleRefresh();
                }}
            />,
            'lg',
            false,
            true
        );
    };

    const handleAdminAssignTicket = (row) => {
        AppCustomDialogHelper.show(
            'Phân phối công việc',
            <DialogAdminAssignTicketView
                item={row}
                onCancel={() => AppCustomDialogHelper.hide()}
                onDone={() => {
                    AppCustomDialogHelper.hide();
                    handleRefresh();
                }}
            />,
            'md',
            false,
            true
        );
    }

    const handleUpdateTicket = (row) => {
        AppCustomDialogHelper.show(
            'Cập nhật nội dung sửa chữa/bảo trì',
            <DialogMaintainerUpdateTicketView
                item={row}
                onCancel={() => AppCustomDialogHelper.hide()}
                onDone={() => {
                    AppCustomDialogHelper.hide();
                    handleRefresh();
                }}
            />,
            'lg',
            false,
            true
        );
    }

    const handleConfirmCompleteTicket = (row) => {
        AppCustomDialogHelper.show(
            'Hoàn thành sửa chữa/bảo trì',
            <DialogMaintainerCompleteTicketView
                item={row}
                onCancel={() => AppCustomDialogHelper.hide()}
                onDone={() => {
                    AppCustomDialogHelper.hide();
                    handleRefresh();
                }}
            />,
            'md',
            false,
            true
        );
    }

    const handleUploadInvoiceDocument = (row) => {
        AppCustomDialogHelper.show(
            'Tạo hóa đơn mua hàng',
            <DialogUploadInvoiceDocumentView
                item={row}
                onCancel={() => AppCustomDialogHelper.hide()}
                onDone={() => {
                    AppCustomDialogHelper.hide();
                    handleRefresh();
                }}
            />,
            'lg',
            false,
            true
        );
    }

    const handleAdminCreateAcceptance = (row) => {
        AppCustomDialogHelper.show(
            'Nghiệm thu',
            <DialogCreateAcceptanceView
                item={row}
                onCancel={() => AppCustomDialogHelper.hide()}
                onDone={() => {
                    AppCustomDialogHelper.hide();
                    handleRefresh();
                }}
            />,
            'md',
            false,
            true
        );
    }

    const handleTicketDirection = (row) => {
        const origin = null;

        const destination = {
            lat: row.chargeStation?.latitude,
            lng: row.chargeStation?.longitude,
        };

        Utils.openGoogleMapsDirection(origin, destination, 'driving');
    }

    // xuat file excel
    const handleExportExcel = async (exportData, params) => {
        let exportDataList = exportData;
        if (_.isEmpty(exportDataList)) {
            ToastHelper.showError('Không có dữ liệu để tải xuống');
            return;
        }

        const sheetFileName = 'Danh_sách_công_việc_' + moment(params.from).format('DDMMYYYY') + '_' + moment(params.to).format('DDMMYYYY');
        const ext = '.xlsx';
        const workbook = new ExcelJS.Workbook();
        const sheet = workbook.addWorksheet(sheetFileName, {
            headerFooter: { firstHeader: sheetFileName },
        });

        sheet.mergeCells('A1:P1');
        sheet.getCell('A1').value = `DANH SÁCH CÔNG VIỆC (NGÀY ${moment(params.from).format(
            'DD/MM/YYYY'
        )} - ${moment(params.to).format('DD/MM/YYYY')})`;
        sheet.getCell('A1').font = {
            name: 'Times New Roman',
            family: 4,
            size: 11,
            bold: true,
            color: { argb: 'FFFFFFFF' },
        };
        sheet.getCell('A1').alignment = { vertical: 'middle', horizontal: 'center' };
        sheet.getCell('A1').fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: '29618E' },
            color: { argb: 'FFFFFF' },
        };
        sheet.getCell('A1').border = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' },
        };
        sheet.getRow(1).height = 25;

        const columns = [
            { key: 'stt', width: 7 },
            { key: 'ticketCode', width: 18 },
            { key: 'stationName', width: 35 },
            { key: 'pointName', width: 15 },
            { key: 'description', width: 35 },
            { key: 'ticketAddress', width: 35 },
            { key: 'type', width: 15 },
            { key: 'maintainerName', width: 30 },
            { key: 'priority', width: 15 },
            { key: 'status', width: 30 },
            { key: 'createdBy', width: 30 },
            { key: 'createdAt', width: 22 },
            { key: 'deadline', width: 22 },
            { key: 'completedDate', width: 22 },
            { key: 'paymentStatus', width: 22 },
            { key: 'totalAmount', width: 22 },
        ];
        sheet.columns = columns;

        sheet.getRow(2).height = 30;
        sheet.getRow(2).font = {
            name: 'Times New Roman',
            family: 4,
            size: 11,
            bold: true,
        };
        sheet.getRow(2).alignment = {
            vertical: 'middle',
            horizontal: 'center',
            wrapText: true,
        };

        sheet.getCell('A2').value = 'STT';
        sheet.getCell('B2').value = 'Mã công việc';
        sheet.getCell('C2').value = 'Trạm sạc';
        sheet.getCell('D2').value = 'Trụ sạc lỗi';
        sheet.getCell('E2').value = 'Mô tả của người báo lỗi';
        sheet.getCell('F2').value = 'Vị trí trạm sạc';
        sheet.getCell('G2').value = 'Loại công việc';
        sheet.getCell('H2').value = 'Kỹ thuật viên';
        sheet.getCell('I2').value = 'Độ ưu tiên';
        sheet.getCell('J2').value = 'Trạng thái công việc';
        sheet.getCell('K2').value = 'Người báo lỗi';
        sheet.getCell('L2').value = 'Thời gian gửi lỗi';
        sheet.getCell('M2').value = 'Thời gian cần xử lý';
        sheet.getCell('N2').value = 'Thời gian hoàn thành';
        sheet.getCell('O2').value = 'Trạng thái thanh toán';
        sheet.getCell('P2').value = 'Tổng chi phí (VNĐ)';


        ['A2:P2'].forEach((range) => {
            sheet.getRow(range.split(':')[0].slice(1)).eachCell({ includeEmpty: true }, (cell) => {
                cell.border = {
                    top: { style: 'thin' },
                    left: { style: 'thin' },
                    bottom: { style: 'thin' },
                    right: { style: 'thin' },
                };
            });
        });

        let i = 1;
        exportDataList?.forEach((row) => {
            // Vi tri tram sac
            const area = ChargeHelper.Utils.getAreaById([areaTree], row?.chargeStation?.areaId);
            let parentArea;
            if (area?.typeCode === 'W') {
                parentArea = ChargeHelper.Utils.getAreaById([areaTree], area?.parentId);
            }
            const addressResult = [row?.chargeStation?.address, area?.name, parentArea?.name]
                .filter(Boolean)
                .join(', ');

            const dataRow = sheet.addRow({
                stt: i++,
                ticketCode: row?.ticketCode ?? (row.ticketId),
                stationName: row?.chargeStation?.name ?? '',
                pointName: row?.chargePoint?.pointCode ?? '',
                description: row?.description ?? '',
                ticketAddress: addressResult?.length > 0 ? addressResult : '',
                type: _.find(MaintainerHelper.Data.ticketTypeOptions, (item) => item.value === row?.type)?.name,
                maintainerName: row?.user?.fullname ?? '',
                priority: MaintainerHelper.Utils.getTicketPriorityName(row?.priority),
                status: MaintainerHelper.Utils.getTicketStatusName(row?.status),
                createdBy: row?.createdBy?.fullname ?? '',
                createdAt: Utils.formatDateTimeToString(row?.createdAt, 'DD/MM/YYYY - HH:mm'),
                deadline: Utils.formatDateTimeToString(row?.deadline, 'DD/MM/YYYY - HH:mm'),
                completedDate: Utils.formatDateTimeToString(row?.completedAt, 'DD/MM/YYYY - HH:mm'),
                paymentStatus: MaintainerHelper.Utils.getPaymentStatusName(row?.paymentStatus),
                totalAmount: Utils.formatNumber(row?.amount ?? 0),
            });

            dataRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
                cell.border = {
                    top: { style: 'thin' },
                    left: { style: 'thin' },
                    bottom: { style: 'thin' },
                    right: { style: 'thin' },
                };
                if (colNumber === 1) {
                    cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
                } else if (colNumber >= 16 && colNumber <= 16) {
                    cell.alignment = { vertical: 'middle', horizontal: 'right', wrapText: true };
                } else {
                    cell.alignment = { vertical: 'middle', horizontal: 'left', wrapText: true };
                }
            });
        });

        sheet.eachRow((row, rowNumber) => {
            if (rowNumber >= 3) {
                row.font = {
                    name: 'Times New Roman',
                    family: 4,
                    size: 11,
                    bold: false,
                };
            }
        });

        workbook.xlsx.writeBuffer().then(function (data) {
            const blob = new Blob([data], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            const url = window.URL.createObjectURL(blob);
            const anchor = document.createElement('a');
            anchor.href = url;
            anchor.download = sheetFileName + ext;
            anchor.click();
            window.URL.revokeObjectURL(url);
            ToastHelper.showSuccess('Tải xuống file Excel thành công');
            AppCustomDialogHelper.hide();
        });
    };

    return (
        <div className='mx-4'>
            {UIHelper.buildCard(
                <div className={!hasAppTab ? "pb-4" : "py-4"}>
                    {/* header */}
                    {!hasAppTab && (
                        <div className="px-4 pt-4 pb-3 d-flex align-items-center justify-content-between">
                            <div className="d-flex flex-column">
                                <span style={UIHelper.buildFontStyle('600', '18px', AppColors.gray[800])}>
                                    {isMine
                                        ? 'Công việc của tôi'
                                        : agencyRole
                                            ? 'Danh sách công việc bảo trì/sửa chữa'
                                            : 'Danh sách công việc'
                                    }
                                </span>
                                <span style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[800])}>
                                    Tổng số:{' '}
                                    <span style={UIHelper.buildFontStyle('600', '14px', AppColors.primary)}>
                                        {Utils.formatNumber(total != 0 ? total : ticketList?.length)} công việc
                                    </span>
                                </span>
                            </div>
                            {adminRole && (
                                <div className="d-flex align-items-center justify-content-end gap-3 flex-wrap">
                                    {UIHelper.buildBlueButton(
                                        'Tải xuống',
                                        async () => {
                                            try {
                                                ChargeHelper.UI.Excel.showDialogDownloadExcelFile(
                                                    MaintainerHelper.Filter.ticketList,
                                                    async (params) => {
                                                        try {
                                                            const { tickets = [] } = await MaintainerHelper.API.requestGetTicketList(params);
                                                            return handleExportExcel(tickets, params);
                                                        } catch (error) {
                                                            ToastHelper.showError(`Lỗi khi lấy dữ liệu: ${error.message}`);
                                                            return [];
                                                        }
                                                    },
                                                );
                                            } catch (error) {
                                                ToastHelper.showError(`Lỗi khi khởi tạo tải xuống: ${error.message}`);
                                            }
                                        },
                                        <i className="fa-regular fa-download" />
                                    )}
                                    {UIHelper.buildGreenButton(
                                        'Thêm công việc',
                                        handleAddNew,
                                        <i className="fa-regular fa-circle-plus" style={{ fontSize: 15 }} />
                                    )}
                                </div>
                            )}

                            {agencyRole && (
                                <div className="d-flex align-items-center justify-content-end gap-3 flex-wrap">
                                    {UIHelper.buildGreenButton(
                                        'Báo lỗi trụ sạc',
                                        () => {
                                            MaintainerHelper.UI.showDialogReportErrorPoint(null, handleRefresh)
                                        },
                                        <i className="fa-regular fa-circle-plus" style={{ fontSize: 15 }} />
                                    )}
                                    {UIHelper.buildBlueButton(
                                        'Tạo lịch bảo trì định kỳ',
                                        () => {
                                            MaintainerHelper.UI.showDialogCreateMaintenanceSchedule(null, handleRefresh)
                                        },
                                        <i className="fa-regular fa-circle-plus" style={{ fontSize: 15 }} />
                                    )}
                                </div>
                            )}
                        </div>
                    )}

                    {/* table */}
                    <div className="">
                        {/* filter */}
                        <div className="row m-0 p-0 px-2">
                            {/* tim kiem */}
                            <div className="col mb-4 px-2 pt-1">
                                {UIHelper.buildFormLabel('Tìm kiếm')}
                                <KTFormSearch
                                    name="search-bar"
                                    placeholder={
                                        adminRole && !maintainerUserId
                                            ? 'Theo mã công việc, trụ sạc, kỹ thuật viên'
                                            : 'Theo mã công việc, trụ sạc'
                                    }
                                    value={MaintainerHelper.Filter.ticketList.q}
                                    onSubmit={(text) => {
                                        const newFilter = {
                                            ...MaintainerHelper.Filter.ticketList,
                                            q: text,
                                            page: 0,
                                        };
                                        MaintainerHelper.Filter.ticketList = newFilter;
                                        setFilter(newFilter);
                                        setFilterDropdown(newFilter);
                                    }}
                                />
                            </div>
                            {/* loc theo tram sac */}
                            {!stationId && (
                                <div className="col mb-4 px-2 pt-1">
                                    {UIHelper.buildFormLabel('Trạm sạc')}
                                    {dropdownStationEl}
                                </div>
                            )}

                            {/* loc theo trang thai cong viec */}
                            {(adminRole || isMine || agencyRole) && (
                                <div className="col mb-4 p-0 px-2">
                                    <KTDropdownFilter
                                        label="Trạng thái công việc"
                                        filterKey="status"
                                        options={
                                            adminRole
                                                ? [{ name: 'Tất cả', value: '' }, ...MaintainerHelper.Data.ticketStatusOptions]
                                                : [{ name: 'Tất cả', value: '' }, ...MaintainerHelper.Data.maintainerTicketStatusOptions]
                                        }
                                        selectedValue={MaintainerHelper.Filter.ticketList.status}
                                        handleChange={(value) => {
                                            updateFilter('status', value);
                                            updateFilter('page', 0);
                                        }}
                                        direction={hasAppTab ? KTBSDropdownDirections.up : KTBSDropdownDirections.down}
                                    />
                                </div>
                            )}

                            {/* loc theo vi tri cong viec */}
                            {!adminRole && !isMine && !agencyRole && (
                                <div className="col mb-4 p-0 px-2">
                                    <KTDropdownFilter
                                        label="Vị trí"
                                        filterKey="locationType"
                                        options={[
                                            { name: 'Vị trí đăng ký làm việc', value: 'WORK-LOCATION' },
                                            { name: 'Vị trí hiện tại', value: 'LIVE-LOCATION' },
                                        ]}
                                        selectedValue={MaintainerHelper.Filter.ticketList.locationType}
                                        handleChange={(value) => {
                                            const updateLocation = (locationType, latitude, longitude) => {
                                                updateFilter('locationType', locationType);
                                                updateFilter('latitude', latitude);
                                                updateFilter('longitude', longitude);
                                            };

                                            if (value === 'WORK-LOCATION') {
                                                const latitude = user?.agency?.workAddress?.latitude;
                                                const longitude = user?.agency?.workAddress?.longitude;

                                                if (latitude !== undefined && longitude !== undefined) {
                                                    updateLocation(value, latitude, longitude);
                                                }
                                            }

                                            else if (value === 'LIVE-LOCATION') {
                                                if (currentLat, currentLon) {
                                                    updateLocation(value, currentLat, currentLon);
                                                } else {
                                                    ToastHelper.showError('Bạn đã từ chối chia sẻ vị trí. Vui lòng vào cài đặt trình duyệt để bật lại quyền truy cập vị trí.');
                                                }
                                            }
                                        }}
                                        direction={hasAppTab ? KTBSDropdownDirections.up : KTBSDropdownDirections.down}
                                    />
                                </div>
                            )}

                            {/* loc theo do uu tien */}
                            {!stationId && (
                                <div className="col mb-4 p-0 px-2">
                                    <KTDropdownFilter
                                        label="Độ ưu tiên"
                                        filterKey="priority"
                                        options={[
                                            { name: 'Tất cả', value: '' },
                                            ...MaintainerHelper.Data.ticketPriorityOptions
                                        ]}
                                        selectedValue={MaintainerHelper.Filter.ticketList.priority}
                                        handleChange={(value) => {
                                            updateFilter('priority', value);
                                        }}
                                        direction={hasAppTab ? KTBSDropdownDirections.up : KTBSDropdownDirections.down}
                                    />
                                </div>
                            )}

                            {stationId && (
                                <>
                                    {/* loc theo trang thai thanh toan */}
                                    <div className="col mb-4 p-0 px-2">
                                        <KTDropdownFilter
                                            label="Trạng thái thanh toán"
                                            filterKey="paymentStatus"
                                            options={[
                                                { name: 'Tất cả', value: '' },
                                                ...MaintainerHelper.Data.paymentStatusOptions
                                            ]}
                                            selectedValue={MaintainerHelper.Filter.ticketList.paymentStatus}
                                            handleChange={(value) => {
                                                updateFilter('paymentStatus', value);
                                            }}
                                            direction={hasAppTab ? KTBSDropdownDirections.up : KTBSDropdownDirections.down}
                                        />
                                    </div>
                                    {/* loc theo thoi gian gui loi */}
                                    <div className="col mb-4 p-0 px-2 pt-2">
                                        <label htmlFor="filterByDate" className="mb-0 mr-2 font-weight-bolder">
                                            Thời gian gửi lỗi
                                        </label>
                                        <CustomDateRangePicker
                                            toggleElementBorderRadius={5}
                                            alignRight={true}
                                            initialValue={MaintainerHelper.Filter.ticketList.createdSelectedValue}
                                            filterComponent={{ from: filterDropdown?.createdFrom, to: filterDropdown?.createdTo }}
                                            onPressSave={(selectedValue, startDate, endDate) => {
                                                updateFilter('createdFrom', startDate);
                                                updateFilter('createdTo', endDate);
                                                updateFilter('createdSelectedValue', selectedValue);
                                            }}
                                            direction={hasAppTab ? KTBSDropdownDirections.up : KTBSDropdownDirections.down}
                                        />
                                    </div>
                                </>
                            )}

                            {/* bo loc */}
                            <div className="col mb-4 p-2 d-flex align-items-end gap-3">
                                <DropdownFilterTable
                                    filterComponent={[
                                        <div>
                                            <MaintainerTicketListFilterView
                                                selectedChargeStation={selectedChargeStation}
                                                setSelectedChargeStation={setSelectedChargeStation}
                                                setFilterDropdown={setFilterDropdown}
                                                filterDropdown={filterDropdown}
                                                adminRole={adminRole}
                                                agencyRole={agencyRole}
                                                isMine={isMine}
                                                stationId={stationId}
                                                currentLat={currentLat}
                                                currentLon={currentLon}
                                            />
                                        </div>
                                    ]}
                                    resetDefaultTable={() => {
                                        const updateFilterDropdown = {
                                            ...filterDropdown,
                                            page: 0,
                                            limit: AppConfigs.defaultPageLimit,
                                            status: '',
                                            q: '',
                                            type: '',
                                            priority: '',
                                            userId: '',
                                            stationId: '',
                                            pointId: '',
                                            hasFee: '',
                                            paymentStatus: '',
                                            locationType: 'WORK-LOCATION',
                                            latitude: '',
                                            longitude: '',
                                            timeFilterType: 'CREATED_DATE',
                                            selectedValue: dateFilter.tatCaThoiGian,
                                            from: getDateFilterOption(dateFilter.tatCaThoiGian)[0].format('YYYY-MM-DD'),
                                            to: getDateFilterOption(dateFilter.tatCaThoiGian)[1].format('YYYY-MM-DD'),
                                            createdSelectedValue: dateFilter.tatCaThoiGian,
                                            createdFrom: getDateFilterOption(dateFilter.tatCaThoiGian)[0].format('YYYY-MM-DD'),
                                            createdTo: getDateFilterOption(dateFilter.tatCaThoiGian)[1].format('YYYY-MM-DD'),
                                        };
                                        setFilterDropdown(updateFilterDropdown);
                                        setFilter(updateFilterDropdown);
                                        MaintainerHelper.Filter.ticketList = updateFilterDropdown;
                                        setSelectedChargeStation([]);
                                    }}
                                    saveFilter={() => {
                                        setFilter(filterDropdown);
                                        MaintainerHelper.Filter.ticketList = filterDropdown;
                                    }}
                                    isDefaultFilter={Utils.checkDefaultFilter(
                                        ['role', 'page', 'limit', 'from', 'to', 'selectedValue', 'createdFrom', 'createdTo', 'createdSelectedValue', 'locationType', 'latitude', 'longitude', 'timeFilterType'],
                                        filter,
                                    )}
                                    direction={hasAppTab ? KTBSDropdownDirections.up : KTBSDropdownDirections.down}
                                />
                                {/* cau hinh cot */}
                                {!stationId && (
                                    <DropdownTableConfigColumn
                                        columnIds={columnIds}
                                        fullColumns={fullColumns}
                                        fullColumnIds={fullColumnsIdSorted}
                                        onChangeCheckboxValue={onChangeCheckboxValue}
                                        saveChanges={saveChanges}
                                        resetDefaultTableColumn={() => {
                                            setFullColumnIds(defaultColumnIds);
                                            resetDefaultTableColumn();
                                        }}
                                        onChangeFullColumnIds={(ids) => {
                                            setFullColumnIds(ids);
                                            const key = prefKey + '_FULL_COLUMN_IDS';
                                            localStorage.setItem(key, ids.join('|'));
                                        }}
                                        onSelectAll={onSelectAll}
                                        onUnSelectAll={onUnSelectAll}
                                        direction={hasAppTab ? KTBSDropdownDirections.up : KTBSDropdownDirections.down}
                                    />
                                )}
                                {/* them cong viec */}
                                {adminRole && stationId && (
                                    <div className="">
                                        {UIHelper.buildGreenButton(
                                            'Thêm công việc',
                                            handleAddNew,
                                            <i className="fa-regular fa-circle-plus" style={{ fontSize: 15 }} />
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="px-4">
                            <KTTable
                                columns={columns}
                                items={ticketList}
                                selectableRows={false}
                                striped={false}
                                compactGrid={false}
                                onClickedRow={(row) => { }}
                                onSelectedRowsChanged={(rows) => { }}
                                onDoubleClickedRow={(rows) => { }}
                                noDataComponent={
                                    <EmptyView
                                        icon={imgEmptyNoData}
                                        title="Không có dữ liệu để hiển thị"
                                        text={<span>Vui lòng kiểm tra kết nối mạng hoặc tải lại trang.</span>}
                                    />
                                }
                            />
                        </div>
                    </div>


                    {/* pagination */}
                    <div className="px-4 mt-2">
                        <KTPagination
                            currentPage={filter.page + 1}
                            rowCount={total != 0 ? total : ticketList?.length}
                            rowsPerPage={filter.limit}
                            currentItemInPageCount={ticketList?.length}
                            onChangePage={(newPage) => {
                                const iNewPage = parseInt(newPage);
                                MaintainerHelper.Filter.ticketList = {
                                    ...MaintainerHelper.Filter.ticketList,
                                    page: iNewPage - 1,
                                };
                                setFilter(MaintainerHelper.Filter.ticketList);
                            }}
                            onChangeRowsPerPage={(newRowsPerPage) => {
                                const iNewRowsPerPage = parseInt(newRowsPerPage);
                                MaintainerHelper.Filter.ticketList = {
                                    ...MaintainerHelper.Filter.ticketList,
                                    limit: iNewRowsPerPage,
                                    page: 0,
                                };
                                setFilter(MaintainerHelper.Filter.ticketList);
                            }}
                            color={KTPaginationColor.success}
                            appendText="công việc"
                        />
                    </div>
                </div>,
                false,
                false,
                true,
                false,
                AppColors.gray[300],
                hasAppTab
            )}
        </div>
    );
}

export default MaintainerTicketListView;
